import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// SW KILLSWITCH — app ne koristi service worker; ako je stari ostao registriran,
// servira zastarjeli build (deployovi "ne stižu") → odjavi ga + očisti CacheStorage.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
}
if (window.caches && window.caches.keys) {
  caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
